module.exports = __webpack_public_path__ + "static/media/gov-house-r.2a39c160.png";